import { AlertTriangle } from '@src/assets';
import React from 'react';
import { Expandable } from './Expandable';
import * as styled from './styled/Alert.styled';

export const Alert: React.FC<{
    alertType: 'error' | 'warning';
    message: string;
    title?: string;
    detailTitle?: string;
    detail?: string;
}> = ({ alertType, message, title, detailTitle, detail }) => {
    return (
        <styled.Alert alertType={alertType}>
            <AlertTriangle />
            <div>
                {title && <styled.Title>{title}</styled.Title>}
                <styled.Message>
                    {message}
                    {detail && <Expandable title={detailTitle ?? 'Detail'}>{detail}</Expandable>}
                </styled.Message>
            </div>
        </styled.Alert>
    );
};
